import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import { IconWarning } from 'components/icons/IconWarning'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'

export const SoilSettingsTitleLink = () => {
  const selectedPropertyId = selectedFieldAssetsStore.getState().property
  const properties = fieldAssetStore.getState().properties

  const favoriteDepthsForAllStations =
    selectedPropertyId && properties
      ? Object.values(properties[selectedPropertyId]?.points || {})
          .filter((point) => !!point?.configuration?.soilProbeDepthsAvailable)
          .map((station) => {
            return station?.configuration?.soilDefaultProbeDepths ?? []
          })
      : []

  const showIconWarning = favoriteDepthsForAllStations.some((depths) => depths.length === 0)
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  const includeRefillPoints = selectedPropertyHasPermission({
    permission: 'EDIT_MANAGEMENT_ALLOWABLE_DEPLETION_DATES',
  })

  const hasStationEditPermission = selectedPropertyHasPermission({ permission: 'EDIT_STATION_SOIL_SETTINGS' })

  const hasSoilCalibrationPermission = selectedPropertyHasPermission({
    permission: 'EDIT_SOIL_CALIBRATION_SETTINGS',
  })

  const includeRootZoneDepths = hasStationEditPermission
  const includeSoilCalibration = hasSoilCalibrationPermission

  if (includeRefillPoints) {
    titleLink.push(
      <>
        <ResponsiveMenuItem
          key="refill-point-dates-menu-item"
          data-role="menu-item"
          onClick={() => {
            detailsPanelStore.setState((prev) => {
              return {
                ...prev,
                refillPointDatesSettingsOpened: true,
              }
            })
          }}
        >
          {translate.phrases.banyanApp('Refill Point (MAD)')}
        </ResponsiveMenuItem>
      </>,
    )
  }

  if (includeRootZoneDepths) {
    titleLink.push(
      <>
        <ResponsiveMenuItem
          key="root-zone-depths-menu-item"
          data-role="menu-item"
          onClick={() => {
            detailsPanelStore.setState((prev) => {
              return {
                ...prev,
                soilSettingsOpened: true,
              }
            })
          }}
        >
          <>
            {showIconWarning && (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  verticalAlign: 'middle',
                  marginRight: '7px',
                }}
              >
                <IconWarning />
              </span>
            )}
            {translate.phrases.banyanApp('Root Zone Depths')}
          </>
        </ResponsiveMenuItem>
      </>,
    )
  }

  if (includeSoilCalibration) {
    titleLink.push(
      <ResponsiveMenuItem
        key="soil-calibration-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              soilCalibrationSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.placeholder('Soil Calibration')}
      </ResponsiveMenuItem>,
    )
  }

  return titleLink
}
